<template>
  <div class="d-flex pl-1">
    <div class="d-flex align-start">
      <span v-if="price == 0" class="font-weight-bold text-h5">free</span>
      <template v-else>
        <span class="body-2" style="margin-top: 5px; margin-right: 1px;">$</span>
        <span class="font-weight-bold text-h5">{{ dollar }}</span>
        <span class="body-2" style="margin-left: 2px; margin-top: 5px;">{{ cents }}</span>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ThePrice',
  props: {
    price: {
      type: Number,
      default: 0
    }
  },
  methods: {
    pad2: function (number) {
      return (number < 10 ? '0' : '') + number;
    }
  },
  computed: {
    dollar: function () {
      if (this.price) { return Math.floor(this.price / 100); }
      return '';
    },
    cents: function () {
      if (this.price) { return this.pad2(this.price % 100); }
      return '';
    }
  }
};
</script>
